import { Box, Text } from '@chakra-ui/react';
import { CdcCardType } from '@ui/views/card-cronos/core/types';
import { useCdcDepositAddress } from '@ui/views/card-cronos/core/utils';
import { useTranslations } from 'next-intl';

import { CdcCard } from './shared/CdcCard';
import { FAQs } from './shared/FAQs';
import { SharedHeader } from './shared/SharedHeader';
import { TopUpAndHistory } from './TopUpAndHistory';

export const CdcCardSecondView = () => {
  const t = useTranslations();
  const { data: card } = useCdcDepositAddress();
  return (
    <Box
      pb={{
        base: '12',
        desktop: '6',
      }}
      px="5"
    >
      <SharedHeader />
      {!!card && (
        <>
          <TopUpAndHistory />
          <Box mt="40px">
            <Text
              textAlign="center"
              textStyle="h3"
              bg="gradients.white-blue-title"
              bgClip="text"
              mb="4"
            >
              {t('card.My Deposit Wallet')}
            </Text>
            <CdcCard type={CdcCardType.Second} />
          </Box>
          <FAQs />
        </>
      )}
    </Box>
  );
};
